module.exports = __webpack_public_path__ + "img/linked_in.42390029.svg";